import Emitter from "./Emitter";

export default class BalanceChange extends Emitter {
    constructor(gb) {
        super(gb);
    }

    SPINGAMES_handler(data) {
        if (data && typeof data !== "object") {
            this.emitTop({ event: "round_result", balance: data });
            this.emitParent({ event: "round_result", balance: data });
        }
    }

    EXCITE_handler(balance) {
        this.emitParent({ event: "setBalance", payload: { balance: balance }});
    }

    PLAYTECH_handler(balance) {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('balanceupdate')) {
            let obj = {
                _type: "ucip.balanceupdate.g2wBalanceUpdateNotification",
                balance: {
                    value: typeof balance === "number" ? balance/100 : balance,
                    winAmount: 0,
                }
            }

            if (this.gb.settings.nativeMobileApp) {
                obj.handled = true;
                window.parent.postMessage(JSON.stringify(obj));

            } else {
                this.emitParent(JSON.stringify(obj));
            }
        }
    }

    LNWOGS_handler(balance) {
        if (balance < 0) return;

        let preSpinBalanceDeduction = this.gb.balanceVersion % 1 !== 0,
            b = JSON.parse(this.gb.settings.walletExtraInfoOnAuthenticate);

        let realBalance = balance / 100,
            bonusBalance = b.bonusBalance ?? 0;

        if (this.gb.wallet?.tmpBalance) {
            bonusBalance = this.gb.wallet.tmpBalance.bonusBalance ?? 0;
        }

        if (preSpinBalanceDeduction && bonusBalance > 0) {
            bonusBalance = bonusBalance - (this.gb.betAmount / 100);
        }

        if (bonusBalance < 0) {
            // the spin where he ran out of bonus money, so some goes from bonus and some from realBalance

            // TODO: not totally sure if ok to add betAmount back to realBalance ... if not ok, revisit this logic ... LOOKS LIKE THIS IS NOT NEEDED ... REMOVE AFTER CONFIRMATION BY OPERATOR
            // realBalance = (balance + this.gb.betAmount) / 100;

            this.gb.wallet.balanceChange(realBalance + bonusBalance, 0);
        } else {
            this.gb.wallet.balanceChange(realBalance - bonusBalance, bonusBalance);
        }
    }

    _default(balance) {
        if(balance && balance.payload) {
            this.gb.balance = balance.payload.balance;
        } else {
            this.gb.balance = balance;
        }

        this.emitTop({ wpgaction: "balance", param: { balance: balance } });
        this.emitParent({ wpgaction: "balance.parent", param: { balance: balance } });
        this.emitiOS({ wpgaction: "balance", param: { balance: balance } });
    }
}
